var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmallEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.31548 14.4345C1.1051 14.4341 0.904535 14.3454 0.762733 14.19C0.618318 14.0358 0.546557 13.8274 0.565483 13.617L0.749233 11.5965L9.23773 3.11098L11.8905 5.76298L3.40423 14.2477L1.38373 14.4315C1.36048 14.4337 1.33723 14.4345 1.31548 14.4345ZM12.42 5.23273L9.76798 2.58073L11.3587 0.989985C11.4994 0.849152 11.6903 0.77002 11.8894 0.77002C12.0884 0.77002 12.2793 0.849152 12.42 0.989985L14.0107 2.58073C14.1516 2.72141 14.2307 2.9123 14.2307 3.11136C14.2307 3.31042 14.1516 3.50131 14.0107 3.64198L12.4207 5.23198L12.42 5.23273Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallEdit);
export default __webpack_public_path__ + "static/media/smallEdit.6dc09599.svg";
export { ForwardRef as ReactComponent };